import { property } from '@wonderlandengine/api/decorators.js';
import { Component, Material } from '@wonderlandengine/api';

/**
 * Material Description:
 */
export class MaterialDescription extends Component {
	static TypeName = 'material-description';

	//-----------------------------------------------------------------------------------------
	// Inspector Variables:
	//-----------------------------------------------------------------------------------------

	@property.string('')
	id: string = '';

	@property.material()
	material: Material | null = null;
}
